import * as React from 'react';

const ERPCreateNewScenarioButton = ({ onNewScenarioCreate }: { onNewScenarioCreate?: () => void }) => {
	return (
		<button className='btn-default' onClick={onNewScenarioCreate}>
			<svg
				className='inline-block relative -mt-0.5 h-4 w-4'
				fill='none'
				stroke='currentColor'
				viewBox='0 0 24 24'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					d='M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z'
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth='2'
				></path>
			</svg>
			&nbsp;Create new scenario
		</button>
	);
};

export default React.memo(ERPCreateNewScenarioButton);
